'use strict';

const { h } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');

const SidebarBrowseLetter = require('../../merchant/views/sidebar-browse-letter');
const SidebarBrowseMerchant = require('../../merchant/views/sidebar-browse-merchant');
const SidebarBrowseAtoz = require('../../merchant/views/sidebar-browse-atoz');
const EmailSubscription = require('../../email_subscription/views/email-subscription');
const Carousel = require('../../../components/carousel');
const localisationParser = require('../../support/localisation-parser');
const { pruneData } = require('../../support/prune-data');

function getCategoryDescription(category) {
  return h(WithI18n, {}, i18n =>
    h('.category-offers-description', {
      dangerouslySetInnerHTML: {
        __html: localisationParser.parse(
          i18n.t(`modules.category.Description.${category}`)
        ),
      },
    })
  );
}

function CategorySideBar({
  advertsForCarousel,
  routes,
  categoryId,
  isTouch,
  leaderboardBanner,
  csrfToken,
  categoryMerchants,
}) {
  return [
    Carousel({
      routes: pruneData(routes, 'merchant:show'),
      items: advertsForCarousel,
      isTouch,
    }),
    h('.category-offers-section', [
      h('h3.category-offers-heading', [
        h(
          Translate,
          { attrs: { class: 'category-offers-about' } },
          'modules.category.About'
        ),
        h(Translate, `modules.category.Name.${categoryId}`),
      ]),
      getCategoryDescription(categoryId),
    ]),
    h(
      '.category-offers-section',
      SidebarBrowseAtoz({
        routes: pruneData(routes, 'all_brands:main'),
        bhcName: `categoryBrowseByAtoz:${categoryId}`,
      })
    ),
    isTouch && leaderboardBanner,
    EmailSubscription({
      csrfToken,
      routes,
      classNames: {
        outer: 'category-offers-section',
      },
      bhwName: `CategoryEmailSubscription:${categoryId}`,
    }),
    h(
      '.category-offers-section',
      {
        'data-bhw': 'CategoryBrowseByStore',
      },
      h(SidebarBrowseLetter, { routes })
    ),
    categoryMerchants.length > 0 &&
      h(SidebarBrowseMerchant, {
        routes,
        className: '.category-offers-section',
        merchants: categoryMerchants,
        localisation: {
          resource: 'modules.shared.TopBrands',
          data: { tag: 'h3', attrs: { class: 'sidebar-browse-title' } },
        },
      }),
  ];
}

module.exports = CategorySideBar;
